module.exports = __webpack_public_path__ + "img/fog.c356784f.svg";